import http from 'hub-http/clients/apiClient';
const root = '/product-updates/v3/rollout-product-updates';
export const fetchRolloutProductUpdates = ({
  endReleaseDate,
  endStageDate,
  enrollmentStatus,
  featureGroup,
  impactLevels,
  isFavorite,
  limit,
  offset,
  product,
  query,
  recommended,
  rolloutState,
  rolloutType,
  sortReleaseDate,
  sortStageDate,
  startReleaseDate,
  startStageDate
}) => {
  return http.get(`${root}/list`, {
    query: {
      endReleaseDate,
      endStageDate,
      enrollmentStatus,
      featureGroup,
      impactLevels,
      isFavorite,
      limit,
      offset,
      product,
      query,
      recommended,
      rolloutState,
      rolloutType,
      sortReleaseDate,
      sortStageDate,
      startReleaseDate,
      startStageDate
    }
  });
};
export const fetchRolloutProductUpdateByUpdateId = ({
  id
}) => {
  return http.get(`${root}/${id}`);
};
export const fetchRolloutProductUpdateByRolloutId = ({
  id
}) => {
  return http.get(`${root}/rollout/${id}`);
};
export const fetchRecommendedRolloutProductUpdates = ({
  endReleaseDate,
  endStageDate,
  enrollmentStatus,
  featureGroup,
  impactLevels,
  isFavorite,
  limit,
  offset,
  product,
  query,
  recommended,
  rolloutState,
  rolloutType,
  sortReleaseDate,
  sortStageDate,
  startReleaseDate,
  startStageDate
}) => {
  return http.get(`${root}/list/recommended`, {
    query: {
      endReleaseDate,
      endStageDate,
      enrollmentStatus,
      featureGroup,
      impactLevels,
      isFavorite,
      limit,
      offset,
      product,
      query,
      recommended,
      rolloutState,
      rolloutType,
      sortReleaseDate,
      sortStageDate,
      startReleaseDate,
      startStageDate
    }
  });
};